
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexLLPrLB4BEOjRA_45yVHxqEHtjv95ChPaOHBga_45_45qBhXUsMeta } from "/codebuild/output/src3021053802/src/pages/index.vue?macro=true";
import { default as index67iXEML3HjwSeV_45T_45SRNfkDUC3fmGNPan8cpywB6HicMeta } from "/codebuild/output/src3021053802/src/pages/login/index.vue?macro=true";
import { default as indexMLRe77PWZAPwEzzhq_45nDrqEDZl7weZ5aIyuS2EUDv0IMeta } from "/codebuild/output/src3021053802/src/pages/software/index.vue?macro=true";
import { default as indexaGtEuMw8b79NwWoUdpoANLrCk8tIpl02c5RkT5AGazkMeta } from "/codebuild/output/src3021053802/src/pages/trackers/index.vue?macro=true";
import { default as index5VE_eOHZuKFUYHVtXGB_znzVoo2_45IjE0GIYYTuHsb7EMeta } from "/codebuild/output/src3021053802/src/pages/templates/index.vue?macro=true";
import { default as createkjx_wqDmy_45k6xYPQJviaNO41HMzJZhKROkULkdb1zpsMeta } from "/codebuild/output/src3021053802/src/pages/trackers/create.vue?macro=true";
import { default as createFfRDCn7_GDFIk0rYyS_45K2_4yuG2E8t3wUIWypSJ8IxsMeta } from "/codebuild/output/src3021053802/src/pages/templates/create.vue?macro=true";
import { default as indexxUZctrWR4pL02vXA2cYKPOogx_45kU_45fMKlMMG08AibrgMeta } from "/codebuild/output/src3021053802/src/pages/tagging-docs/index.vue?macro=true";
import { default as editC0kdCkr2otBC1zo_Mh2ym9u4_45FuyGPu3bq4WhSAP9_45cMeta } from "/codebuild/output/src3021053802/src/pages/trackers/[id]/edit.vue?macro=true";
import { default as _91token_934mV_45WSUMXG6SjxUD9x_45JCH_KjK8xDElGKrWR7a3uJpwMeta } from "/codebuild/output/src3021053802/src/pages/login/token/[token].vue?macro=true";
import { default as editaGxh_wDlYiwB7TZ7sOME_c9EIT01iuev24L15paxv3UMeta } from "/codebuild/output/src3021053802/src/pages/templates/[id]/edit.vue?macro=true";
import { default as indexhCVF8JQN_45Qcpema_45jqyZlVOg_458bre0YfLN92k_45C1QMYMeta } from "/codebuild/output/src3021053802/src/pages/templates/[id]/index.vue?macro=true";
import { default as indexhi8XLCjHu7feM64P9PGOV8aAOiG0X6Bkn_zpDj2PRzIMeta } from "/codebuild/output/src3021053802/src/pages/plan-management/index.vue?macro=true";
import { default as indexFEGrp5Qfg3qR8XoXYjI_w1L6jeO_45rRNOLhCUeYOBW9QMeta } from "/codebuild/output/src3021053802/src/pages/dropcode-generator/index.vue?macro=true";
import { default as indexTEtqsBNZDgoDEWhS78CEnBnbR8Ace_45_45CUwAictrpIywMeta } from "/codebuild/output/src3021053802/src/pages/standalone-snowplow/index.vue?macro=true";
import { default as indexNi9StNb0tMXzN2g30LmtV0bVvJJ51adujPFiZtht2VEMeta } from "/codebuild/output/src3021053802/src/pages/trackers/[id]/events/index.vue?macro=true";
import { default as indexMmQpV2q_LF47AD_1qNfr2Mbn7eN7E_WqDQhMgIH_457aoMeta } from "/codebuild/output/src3021053802/src/pages/plan-management/[id]/events/index.vue?macro=true";
import { default as createduiebggNkxChLDvMfeM_AoQxlMRHgwMxXHiD1iYr4KEMeta } from "/codebuild/output/src3021053802/src/pages/plan-management/[id]/events/create.vue?macro=true";
import { default as editrXI5_454XO12hDAJsQQKK9L36QCZM_45tYGUZAbJpe_LGPQMeta } from "/codebuild/output/src3021053802/src/pages/plan-management/[id]/events/[eventId]/edit.vue?macro=true";
import { default as eventsr2WnQ6EEm7j_4586nInn0lTj68WYT5Eq0ftI00y1SpTQwMeta } from "/codebuild/output/src3021053802/src/pages/plan-management/[id]/events.vue?macro=true";
import { default as indexuLskJ9Z_454_kLfr_Pm8wkWZFlNusDEhceRiEIgbqb6_45QMeta } from "/codebuild/output/src3021053802/src/pages/templates/[id]/events/index.vue?macro=true";
import { default as createkw0bKm5zCJO5H4dHKEgx3TZgedTIXSxb7PfaNQ_MHKgMeta } from "/codebuild/output/src3021053802/src/pages/trackers/[id]/events/create.vue?macro=true";
import { default as assign_45groupsFXCD0Hti0h6jNW6NXGDrkYmn9XuHNKe6a6ZaB1XzeQgMeta } from "/codebuild/output/src3021053802/src/pages/templates/[id]/assign-groups.vue?macro=true";
import { default as createbULs4cCQxtz6u9gW7ajER3zrasHZ8nD_45wPGhj__Bl_IMeta } from "/codebuild/output/src3021053802/src/pages/templates/[id]/events/create.vue?macro=true";
import { default as indexQQlz9zLwjzVucyG2kuH75__45bG2CmGM_45yht4nJIUyBnQMeta } from "/codebuild/output/src3021053802/src/pages/trackers/[id]/transformers/index.vue?macro=true";
import { default as indexh8qhCjjKUCRTempHtyH2WOMdVL4Oak85pCiIdYYpfj8Meta } from "/codebuild/output/src3021053802/src/pages/templates/[id]/transformers/index.vue?macro=true";
import { default as createhtcgjK_Do2_6cvuKyM538KtLVM0X6CPkUb9YXMgRnIcMeta } from "/codebuild/output/src3021053802/src/pages/trackers/[id]/transformers/create.vue?macro=true";
import { default as retain_45backendhJmi5HpLwvOs_cu6HoGsi8FiNP9kDcsJcINeWdLXkhYMeta } from "/codebuild/output/src3021053802/src/pages/standalone-snowplow/retain-backend.vue?macro=true";
import { default as createhB7AVSs8HZf4esY_dphlQPU3ViqWjOWleU5vUbAjFFMMeta } from "/codebuild/output/src3021053802/src/pages/templates/[id]/transformers/create.vue?macro=true";
import { default as retain_45frontendAU3DgssazO0vEyEymfbLlQinRCfvfe_kuSDnpdX5qH0Meta } from "/codebuild/output/src3021053802/src/pages/standalone-snowplow/retain-frontend.vue?macro=true";
import { default as BaseSoftwarePageOOcYtJ0lMPHWDWW0w9nqV42m4i_4502o9tEN7I0i29rOoMeta } from "/codebuild/output/src3021053802/src/pages/standalone-snowplow/BaseSoftwarePage.vue?macro=true";
import { default as indexU40RkZBoeYnjHDB19UPs5hrfLdrmRvoOMJpRGCRNMpoMeta } from "/codebuild/output/src3021053802/src/pages/trackers/[id]/events/[eventId]/index.vue?macro=true";
import { default as indexwyVsvPs9uUC3QZGOSzuAAumRv7myAXM_45R3S7QNv4lI4Meta } from "/codebuild/output/src3021053802/src/pages/templates/[id]/events/[eventId]/index.vue?macro=true";
import { default as netdirector_45ownershipXOLfI94gGuT1eaNLtxEJ1_452KIbHK_Gmvb_etGOOsUc0Meta } from "/codebuild/output/src3021053802/src/pages/standalone-snowplow/netdirector-ownership.vue?macro=true";
import { default as index9CTNM_VzhdoOduF0zLa_45uvIQqxop6h_3QfNRNIl7qNQMeta } from "/codebuild/output/src3021053802/src/pages/trackers/[id]/events/[eventId]/edit/index.vue?macro=true";
import { default as index9sK8jAjvCPWi48U_455YgFDF0Vd8pMVvKcEYvdgQyaNSoMeta } from "/codebuild/output/src3021053802/src/pages/templates/[id]/events/[eventId]/edit/index.vue?macro=true";
import { default as jlr_45global_45avl_45frontendiZpr0a95P2uK6kmKIJx_45YX91ktgiFz91OshUPR4q44YMeta } from "/codebuild/output/src3021053802/src/pages/standalone-snowplow/jlr-global-avl-frontend.vue?macro=true";
import { default as netdirector_45experience_45v2VGhJGfOPg5Fy84e9INUL7VC252XnuitOF7jTgFUT7fAMeta } from "/codebuild/output/src3021053802/src/pages/standalone-snowplow/netdirector-experience-v2.vue?macro=true";
import { default as editm1SbQ12M9xC9TjpPe82OaeucOG4rIoBfu_450GWyU8V5oMeta } from "/codebuild/output/src3021053802/src/pages/trackers/[id]/transformers/[transformerId]/edit.vue?macro=true";
import { default as edit3kiS7N6S0HLq5uvNpbcfEvUHFud8_l_45jQmzYpZSneLUMeta } from "/codebuild/output/src3021053802/src/pages/templates/[id]/transformers/[transformerId]/edit.vue?macro=true";
import { default as netdirector_45frontend_45componentsEu8JsWoynTIZcBoX_455UdlWvqlJLAZBy8b627ku5ERP0Meta } from "/codebuild/output/src3021053802/src/pages/standalone-snowplow/netdirector-frontend-components.vue?macro=true";
import { default as netdirector_45online_45vehicle_45salesLiEsLxTTgfjYNOPEq2QKl9SPYgeiGfZfykOp4x7GQPUMeta } from "/codebuild/output/src3021053802/src/pages/standalone-snowplow/netdirector-online-vehicle-sales.vue?macro=true";
import { default as indexeY1qgp2WFySYcxLatCQQkSH4hbNxzcjZUh7pT4ZERiIMeta } from "/codebuild/output/src3021053802/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue?macro=true";
import { default as indexVH9_CktAJYJwAkgCX5bsMnArbqNXotoHOWwf_45GRkSjkMeta } from "/codebuild/output/src3021053802/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue?macro=true";
import { default as createbPQZ_gbocbKsI_cYzw9lSniiJzks6Hr3_45MiitDb9o1IMeta } from "/codebuild/output/src3021053802/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue?macro=true";
import { default as createtxiSv5qNWv6_45EZIxmHUwRsjd_juK4lZ1n0ubaX8GN_45UMeta } from "/codebuild/output/src3021053802/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue?macro=true";
import { default as editpV_45MZpNKGOAeIEFfELdMlBZVpcG1bAqfrebLDV73diEMeta } from "/codebuild/output/src3021053802/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue?macro=true";
import { default as editS7Hg0_Uk3qFHsHrtTWexJlUXZUk1w7jYHreKSZwOqJwMeta } from "/codebuild/output/src3021053802/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3021053802/src/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: {"middleware":"auth"},
    component: () => import("/codebuild/output/src3021053802/src/pages/login/index.vue")
  },
  {
    name: "software",
    path: "/software",
    component: () => import("/codebuild/output/src3021053802/src/pages/software/index.vue")
  },
  {
    name: "trackers",
    path: "/trackers",
    component: () => import("/codebuild/output/src3021053802/src/pages/trackers/index.vue")
  },
  {
    name: "templates",
    path: "/templates",
    component: () => import("/codebuild/output/src3021053802/src/pages/templates/index.vue")
  },
  {
    name: "trackers-create",
    path: "/trackers/create",
    component: () => import("/codebuild/output/src3021053802/src/pages/trackers/create.vue")
  },
  {
    name: "templates-create",
    path: "/templates/create",
    component: () => import("/codebuild/output/src3021053802/src/pages/templates/create.vue")
  },
  {
    name: "tagging-docs",
    path: "/tagging-docs",
    component: () => import("/codebuild/output/src3021053802/src/pages/tagging-docs/index.vue")
  },
  {
    name: "trackers-id-edit",
    path: "/trackers/:id()/edit",
    component: () => import("/codebuild/output/src3021053802/src/pages/trackers/[id]/edit.vue")
  },
  {
    name: "login-token-token",
    path: "/login/token/:token()",
    component: () => import("/codebuild/output/src3021053802/src/pages/login/token/[token].vue")
  },
  {
    name: "templates-id-edit",
    path: "/templates/:id()/edit",
    component: () => import("/codebuild/output/src3021053802/src/pages/templates/[id]/edit.vue")
  },
  {
    name: "templates-id",
    path: "/templates/:id()",
    component: () => import("/codebuild/output/src3021053802/src/pages/templates/[id]/index.vue")
  },
  {
    name: "plan-management",
    path: "/plan-management",
    component: () => import("/codebuild/output/src3021053802/src/pages/plan-management/index.vue")
  },
  {
    name: "dropcode-generator",
    path: "/dropcode-generator",
    component: () => import("/codebuild/output/src3021053802/src/pages/dropcode-generator/index.vue")
  },
  {
    name: "standalone-snowplow",
    path: "/standalone-snowplow",
    component: () => import("/codebuild/output/src3021053802/src/pages/standalone-snowplow/index.vue")
  },
  {
    name: "trackers-id-events",
    path: "/trackers/:id()/events",
    component: () => import("/codebuild/output/src3021053802/src/pages/trackers/[id]/events/index.vue")
  },
  {
    name: eventsr2WnQ6EEm7j_4586nInn0lTj68WYT5Eq0ftI00y1SpTQwMeta?.name,
    path: "/plan-management/:id()/events",
    component: () => import("/codebuild/output/src3021053802/src/pages/plan-management/[id]/events.vue"),
    children: [
  {
    name: "plan-management-id-events",
    path: "",
    component: () => import("/codebuild/output/src3021053802/src/pages/plan-management/[id]/events/index.vue")
  },
  {
    name: "plan-management-id-events-create",
    path: "create",
    component: () => import("/codebuild/output/src3021053802/src/pages/plan-management/[id]/events/create.vue")
  },
  {
    name: "plan-management-id-events-eventId-edit",
    path: ":eventId()/edit",
    component: () => import("/codebuild/output/src3021053802/src/pages/plan-management/[id]/events/[eventId]/edit.vue")
  }
]
  },
  {
    name: "templates-id-events",
    path: "/templates/:id()/events",
    component: () => import("/codebuild/output/src3021053802/src/pages/templates/[id]/events/index.vue")
  },
  {
    name: "trackers-id-events-create",
    path: "/trackers/:id()/events/create",
    component: () => import("/codebuild/output/src3021053802/src/pages/trackers/[id]/events/create.vue")
  },
  {
    name: "templates-id-assign-groups",
    path: "/templates/:id()/assign-groups",
    component: () => import("/codebuild/output/src3021053802/src/pages/templates/[id]/assign-groups.vue")
  },
  {
    name: "templates-id-events-create",
    path: "/templates/:id()/events/create",
    component: () => import("/codebuild/output/src3021053802/src/pages/templates/[id]/events/create.vue")
  },
  {
    name: "trackers-id-transformers",
    path: "/trackers/:id()/transformers",
    component: () => import("/codebuild/output/src3021053802/src/pages/trackers/[id]/transformers/index.vue")
  },
  {
    name: "templates-id-transformers",
    path: "/templates/:id()/transformers",
    component: () => import("/codebuild/output/src3021053802/src/pages/templates/[id]/transformers/index.vue")
  },
  {
    name: "trackers-id-transformers-create",
    path: "/trackers/:id()/transformers/create",
    component: () => import("/codebuild/output/src3021053802/src/pages/trackers/[id]/transformers/create.vue")
  },
  {
    name: "standalone-snowplow-retain-backend",
    path: "/standalone-snowplow/retain-backend",
    component: () => import("/codebuild/output/src3021053802/src/pages/standalone-snowplow/retain-backend.vue")
  },
  {
    name: "templates-id-transformers-create",
    path: "/templates/:id()/transformers/create",
    component: () => import("/codebuild/output/src3021053802/src/pages/templates/[id]/transformers/create.vue")
  },
  {
    name: "standalone-snowplow-retain-frontend",
    path: "/standalone-snowplow/retain-frontend",
    component: () => import("/codebuild/output/src3021053802/src/pages/standalone-snowplow/retain-frontend.vue")
  },
  {
    name: "standalone-snowplow-BaseSoftwarePage",
    path: "/standalone-snowplow/BaseSoftwarePage",
    component: () => import("/codebuild/output/src3021053802/src/pages/standalone-snowplow/BaseSoftwarePage.vue")
  },
  {
    name: "trackers-id-events-eventId",
    path: "/trackers/:id()/events/:eventId()",
    component: () => import("/codebuild/output/src3021053802/src/pages/trackers/[id]/events/[eventId]/index.vue")
  },
  {
    name: "templates-id-events-eventId",
    path: "/templates/:id()/events/:eventId()",
    component: () => import("/codebuild/output/src3021053802/src/pages/templates/[id]/events/[eventId]/index.vue")
  },
  {
    name: "standalone-snowplow-netdirector-ownership",
    path: "/standalone-snowplow/netdirector-ownership",
    component: () => import("/codebuild/output/src3021053802/src/pages/standalone-snowplow/netdirector-ownership.vue")
  },
  {
    name: "trackers-id-events-eventId-edit",
    path: "/trackers/:id()/events/:eventId()/edit",
    component: () => import("/codebuild/output/src3021053802/src/pages/trackers/[id]/events/[eventId]/edit/index.vue")
  },
  {
    name: "templates-id-events-eventId-edit",
    path: "/templates/:id()/events/:eventId()/edit",
    component: () => import("/codebuild/output/src3021053802/src/pages/templates/[id]/events/[eventId]/edit/index.vue")
  },
  {
    name: "standalone-snowplow-jlr-global-avl-frontend",
    path: "/standalone-snowplow/jlr-global-avl-frontend",
    component: () => import("/codebuild/output/src3021053802/src/pages/standalone-snowplow/jlr-global-avl-frontend.vue")
  },
  {
    name: "standalone-snowplow-netdirector-experience-v2",
    path: "/standalone-snowplow/netdirector-experience-v2",
    component: () => import("/codebuild/output/src3021053802/src/pages/standalone-snowplow/netdirector-experience-v2.vue")
  },
  {
    name: "trackers-id-transformers-transformerId-edit",
    path: "/trackers/:id()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src3021053802/src/pages/trackers/[id]/transformers/[transformerId]/edit.vue")
  },
  {
    name: "templates-id-transformers-transformerId-edit",
    path: "/templates/:id()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src3021053802/src/pages/templates/[id]/transformers/[transformerId]/edit.vue")
  },
  {
    name: "standalone-snowplow-netdirector-frontend-components",
    path: "/standalone-snowplow/netdirector-frontend-components",
    component: () => import("/codebuild/output/src3021053802/src/pages/standalone-snowplow/netdirector-frontend-components.vue")
  },
  {
    name: "standalone-snowplow-netdirector-online-vehicle-sales",
    path: "/standalone-snowplow/netdirector-online-vehicle-sales",
    component: () => import("/codebuild/output/src3021053802/src/pages/standalone-snowplow/netdirector-online-vehicle-sales.vue")
  },
  {
    name: "trackers-id-events-eventId-edit-fields-fieldId-transformers",
    path: "/trackers/:id()/events/:eventId()/edit/fields/:fieldId()/transformers",
    component: () => import("/codebuild/output/src3021053802/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue")
  },
  {
    name: "templates-id-events-eventId-edit-fields-fieldId-transformers",
    path: "/templates/:id()/events/:eventId()/edit/fields/:fieldId()/transformers",
    component: () => import("/codebuild/output/src3021053802/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/index.vue")
  },
  {
    name: "trackers-id-events-eventId-edit-fields-fieldId-transformers-create",
    path: "/trackers/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/create",
    component: () => import("/codebuild/output/src3021053802/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue")
  },
  {
    name: "templates-id-events-eventId-edit-fields-fieldId-transformers-create",
    path: "/templates/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/create",
    component: () => import("/codebuild/output/src3021053802/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/create.vue")
  },
  {
    name: "trackers-id-events-eventId-edit-fields-fieldId-transformers-transformerId-edit",
    path: "/trackers/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src3021053802/src/pages/trackers/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue")
  },
  {
    name: "templates-id-events-eventId-edit-fields-fieldId-transformers-transformerId-edit",
    path: "/templates/:id()/events/:eventId()/edit/fields/:fieldId()/transformers/:transformerId()/edit",
    component: () => import("/codebuild/output/src3021053802/src/pages/templates/[id]/events/[eventId]/edit/fields/[fieldId]/transformers/[transformerId]/edit.vue")
  }
]